import React from "react";
import { PhoneInTalk, AlternateEmail, LocationOn } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";

const fadeIn = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
};

export default function FooterLong() {
    const { pathname } = useLocation();
    const isContactPage = pathname.includes("contact");

    return (
        <motion.section
            className="bg-gray-50 pt-20 pb-10 px-8 lg:px-28 relative overflow-hidden"
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.3 }}
            variants={fadeIn}
        >
            {/* Soft gradient glow */}
            <div className="absolute top-0 left-0 w-full h-[240px] bg-gradient-to-b from-primary-color/10 to-transparent blur-2xl pointer-events-none" />

            <div className="max-w-6xl mx-auto bg-white/80 backdrop-blur-xl 
                      rounded-3xl shadow-xl border border-gray-200 relative z-10">

                {/* CTA (Hidden on Contact Page) */}
                {!isContactPage && (
                    <div className="text-center px-8 py-14 border-b border-gray-200">
                        <h2 className="text-3xl md:text-5xl font-bold text-gray-900">
                            Let’s Build Something Great
                        </h2>

                        <p className="text-gray-700 max-w-2xl mx-auto mt-4 text-lg leading-relaxed">
                            Have an idea, project, or challenge? We’d love to collaborate with you.
                        </p>

                        <Link
                            to="/contact"
                            className="inline-block mt-8 bg-primary-color text-white px-10 py-4 
                         rounded-xl font-semibold shadow-md hover:shadow-xl 
                         hover:scale-105 transition-all duration-300"
                        >
                            GET IN TOUCH
                        </Link>
                    </div>
                )}

                {/* Main Contact Section */}
                <div className="px-10 py-14 grid grid-cols-1 sm:grid-cols-3 gap-12 text-center">

                    {/* Phone */}
                    <div className="flex flex-col items-center gap-4">
                        <div className="p-4 bg-primary-color/10 rounded-full">
                            <PhoneInTalk className="text-primary-color" fontSize="large" />
                        </div>
                        <p className="font-semibold text-gray-900">Call Us</p>
                        <a
                            href="tel:+917985957362"
                            className="text-gray-700 hover:text-primary-color transition-colors"
                        >
                            +91 7985957362
                        </a>
                    </div>

                    {/* Email */}
                    <div className="flex flex-col items-center gap-4">
                        <div className="p-4 bg-primary-color/10 rounded-full">
                            <AlternateEmail className="text-primary-color" fontSize="large" />
                        </div>
                        <p className="font-semibold text-gray-900">Email Us</p>
                        <a
                            href="mailto:gitsetcode.softwaresolutions@gmail.com"
                            className="text-gray-700 hover:text-primary-color transition-colors break-words px-4"
                        >
                            gitsetcode.softwaresolutions@gmail.com
                        </a>
                    </div>

                    {/* Address */}
                    <div className="flex flex-col items-center gap-4">
                        <div className="p-4 bg-primary-color/10 rounded-full">
                            <LocationOn className="text-primary-color" fontSize="large" />
                        </div>
                        <p className="font-semibold text-gray-900">Location</p>
                        <p className="text-gray-700">Rohini, New Delhi — 110085</p>
                    </div>

                </div>

                {/* Bottom Strip */}
                {/* <div className="bg-gray-100 py-5 border-t border-gray-300 text-center">
                    <p className="text-gray-600 text-sm">
                        © {new Date().getFullYear()} GitSetCode Software Solutions — All Rights Reserved.
                    </p>
                </div> */}
            </div>
        </motion.section>
    );
}
